import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { isValidElement, Fragment } from 'react';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

function maestroComponent(displayName, Component, compoundComponents) {
  Component.displayName = displayName;

  if (compoundComponents) {
    Component = Object.assign(Component, compoundComponents);
  }

  return Component;
}

function findChildWithDisplayName(children, displayName) {
  var _a;

  var childrenArray = children ? React.Children.toArray(children) : [];
  var result;

  if (children && displayName) {
    for (var i = 0; i < childrenArray.length; i++) {
      var child = childrenArray[i];

      if (!
      /*#__PURE__*/
      isValidElement(child)) {
        continue;
      }

      var type = child.type;

      if (type ===
      /* @__PURE__ */
      React.createElement(Fragment, null).type && child.props.children) {
        var deepChild = findChildWithDisplayName(child.props.children, displayName);

        if (deepChild) {
          result = deepChild;
          break;
        }
      }

      if (typeof type === "string") {
        continue;
      }

      if ((_a = type == null ? void 0 : type.displayName) == null ? void 0 : _a.includes(displayName)) {
        result = child;
        break;
      }
    }
  }

  return result;
}

function findAllChildrenWithDisplayName(children, displayName) {
  var childrenArray = children ? React.Children.toArray(children) : [];

  if (children && displayName) {
    var flatten = function flatten(acc, child) {
      if (Array.isArray(child)) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(child.reduce(flatten)));
      }

      return [].concat(_toConsumableArray(acc), [child]);
    };

    return childrenArray.map(function (child) {
      var _a;

      if (!
      /*#__PURE__*/
      isValidElement(child)) {
        return null;
      }

      var type = child.type;

      if (type ===
      /* @__PURE__ */
      React.createElement(Fragment, null).type && child.props.children) {
        return findAllChildrenWithDisplayName(React.Children.toArray(child.props.children), displayName);
      }

      if (typeof type === "string") {
        return null;
      }

      if ((_a = type == null ? void 0 : type.displayName) == null ? void 0 : _a.includes(displayName)) {
        return child;
      }

      return null;
    }).filter(function (child) {
      return Boolean(child);
    }).reduce(flatten, []);
  }

  return [];
}

var getClonedChild = function getClonedChild(children, displayName, props) {
  if (displayName && children) {
    var child = findChildWithDisplayName(children, displayName);

    if (
    /*#__PURE__*/
    isValidElement(child)) {
      return (
        /*#__PURE__*/
        React.cloneElement(child, props && __spreadValues({}, props))
      );
    }
  }

  return null;
};

var getClonedChildWithMergedProps = function getClonedChildWithMergedProps(children, displayName, props) {
  if (displayName && children) {
    var child = findChildWithDisplayName(children, displayName);

    if (
    /*#__PURE__*/
    isValidElement(child)) {
      return (
        /*#__PURE__*/
        React.cloneElement(child, __spreadValues(__spreadValues({}, props), child.props))
      );
    }
  }

  return null;
};

var getDisplayName = function getDisplayName(Component) {
  var _a;

  return (_a = Component == null ? void 0 : Component.type) == null ? void 0 : _a.displayName;
};

export { findAllChildrenWithDisplayName, findChildWithDisplayName, getClonedChild, getClonedChildWithMergedProps, getDisplayName, maestroComponent };